/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/react';
import axios from 'axios';

export const initSentry = (dsn: any) => {
  Sentry.init({
    dsn: dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    beforeSend(event: any, hint: any) {
      // Ignore some known non-actionable unhandled rejections coming from
      // browser tooling/extensions (they reject with a plain string/object).
      const firstException = event?.exception?.values?.[0];
      const exceptionType = firstException?.type;
      const exceptionValue = firstException?.value;
      if (
        exceptionType === 'UnhandledRejection' &&
        typeof exceptionValue === 'string' &&
        exceptionValue.includes('Object Not Found Matching Id:') &&
        exceptionValue.includes('MethodName:')
      ) {
        return null;
      }

      // Ignore expected error getBoundingClientRect from BaseUI
      if (event?.exception) {
        const error = event?.exception?.values?.[0];
        if (
          error &&
          error?.type === 'TypeError' &&
          error?.value?.includes('getBoundingClientRect')
        ) {
          return null;
        }
      }
      if (
        event.exception?.values?.[0]?.value?.includes('NetworkError') ||
        event.message?.includes('Failed to fetch')
      ) {
        return null;
      }
      if (event.exception?.values?.[0]?.value?.includes('Timeout')) {
        return null;
      }
      if (
        axios.isAxiosError(hint?.originalException) &&
        hint?.originalException?.response?.status === 500
      ) {
        return null;
      }
      return event;
    },
  });
};
